import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-receipt-container-store',
  templateUrl: './payment-receipt-container-store.component.html',
  styleUrls: ['./payment-receipt-container-store.component.css']
})
export class PaymentReceiptContainerStoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component.ts